<template>
    <div id="outstanding">

        <v-container fluid>
            <v-card height="70" class="elevation-0 px-2 ">
                <v-card-title>
                    <v-row>
                        <v-col class="pa-0" cols="3">
                            <v-text-field clearable  label="Search" @input="onSearch" outlined v-model="search"></v-text-field>
                        </v-col>
                        <v-spacer/>
                        <!--<v-btn @click="addPaymentDialog=true" class="primary">Add Payment</v-btn>-->
                    </v-row>
                </v-card-title>
            </v-card>
            <v-row>
                <v-col cols="12">
                    <v-data-table :headers="headers" :items="outstanding"  :server-items-length="outstandingCount"
                                  :options.sync="options" @update:options="onUpdateOptions" class="elevation-0 os-table"
                                  :footer-props="{itemsPerPageOptions:rowsPerPageItems}" @click:row="rowClick" @update:page="$vuetify.goTo(0)">
                        <template v-slot:no-data>No Outstanding Available</template>
                        <template v-slot:no-results>No Outstanding Available</template>
                        <template v-slot:item.customerName="{ item }">
<!--                            <div style="padding-top: 18px; padding-bottom: 19px;">-->
                                <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(([{path: item.Customer.profileImage, type: 'IMAGE'}]))" title="View Image">
                                    <v-img v-if="item.Customer.profileImage" :src="imgWpx(item.Customer.profileImage,200)" alt="image" @error="item.Customer.profileImage = null">
                                        <template v-slot:placeholder>
                                            <v-icon size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                                            <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                        </template>
                                    </v-img>
                                    <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                                </v-avatar>
                            <span class="ellipsis c-name"><span :title="item.Customer.name">{{ item.Customer.name}}</span><br>
                            <span :title="item.Customer.mobile" class="f-12 grey--text text--darken-1">{{item.Customer.mobile}}</span>
                            </span>
<!--                            </div>-->
                        </template>
                        <template v-slot:item.print="{item}">
                            <v-btn icon title="Print Ledger" @click.stop="printOutstanding(item)">
                                <v-icon>mdi-printer</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.creditLimit="{ item }">{{ item.creditLimit | currencyFilter}}</template>
                        <template v-slot:item.availableCredit="{ item }">{{ item.availableCredit | currencyFilter}}</template>
                        <template v-slot:item.ordersCount="{ item }">{{ item.Orders_aggregate.aggregate.count }}</template>
                        <template v-slot:item.totalAmount="{ item }">{{ (item.Orders_aggregate.aggregate.sum.payableAmount||0) | currencyFilter }}</template>
                        <template v-slot:item.paidAmount="{ item }">{{ (item.CreditDebit_aggregate.aggregate.sum.amount||0) | currencyFilter }}</template>
                        <template v-slot:item.dueAmount="{ item }">
                            <span class="cell-due-amt red--text">{{(item.Orders_aggregate.aggregate.sum.payableAmount - item.CreditDebit_aggregate.aggregate.sum.amount) | currencyFilter }}</span>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>

        <download-popup :parameters="parameters" :dialog.sync="downloadDialog"></download-popup>
        <add-payment :formDialog.sync="addPaymentDialog"/>
        <gallery id="gallery-outstanding-list" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"></gallery>
    </div>
</template>

<script>
    import Constants from "../../Constants/Constants";
    import moment from 'moment'
    import {debounce} from 'lodash'
    import {SUBSCRIBE_OUTSTANDING, SUBSCRIBE_OUTSTANDING_COUNT} from "../../graphql/subscriptions/Outstanding";
    import DownloadPopup from "./DownloadPopup";
    import AddPayment from "./AddPayment";
    let options= {page: 1, itemsPerPage: 25, offset:0, limit:25};

    export default {
        name: "Outstanding",
        components: {AddPayment, DownloadPopup},
        apollo: {
            $subscribe: {
                outstandingCount:{
                    query: SUBSCRIBE_OUTSTANDING_COUNT,
                    variables () { return { filter: this.filter}},
                    result ({ data }) { this.outstandingCount = data.outstandingCount.aggregate.count },
                },
                outstanding:{
                    query: SUBSCRIBE_OUTSTANDING,
                    variables () { return { filter: this.filter, offset: this.options.offset, limit: this.options.limit}},
                    result ({ data }) { this.outstanding = data.outstanding },
                }
            }
        },
        data () {
            return {
                Constants: Constants,
                moment: moment,
                search: '',
                outstanding: [],
                outstandingCount: 0,
                options: options,
                headers: [
                    { text: 'CUSTOMER', value: 'customerName', width:260 },
                    { text: '', value: 'print' },
                    { text: 'CREDIT LIMIT', value: 'creditLimit', align:'end' },
                    { text: 'AVAILABLE LIMIT', value: 'availableCredit', align:'end' },
                    { text: 'ORDERS', value: 'ordersCount', align:'end' },
                    { text: 'TOTAL AMOUNT', value: 'totalAmount', align:'end' },
                    { text: 'PAID AMOUNT', value: 'paidAmount', align:'end' },
                    { text: 'DUE AMOUNT', value: 'dueAmount', align:'end' },
                ],
                offset: 0, limit: 25, itemsPerPage: 25, rowsPerPageItems: [25, 50, 100, -1],
                filter: '%%',
                galleryImages: [],
                galleryIndex: null,
                parameters: null,
                downloadDialog: false,
                addPaymentDialog: false,
            }
        },
        methods: {
            rowClick(row){
                this.$router.push({ path: '/outstanding/'+row.id})
            },
            onUpdateOptions(val){
                if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                    this.options.limit = this.outstandingCount          //assign total count
                    this.options.offset = 0
                }else{
                    this.options.limit = val.itemsPerPage
                    this.options.offset = (val.page -1) * val.itemsPerPage;
                }
            },
            printOutstanding(row){
              this.parameters = {name:'Ledger', url:`${Constants.api_url}v1/generateLedger`, customerId:row.Customer.id}
              this.downloadDialog = true
            },
            onSearch: debounce(function(val){
                this.filter = val?('%'+val+'%'):'%%'
                this.options = options          //on search, reset page options
            }, 500),
            openGallery(arr){
                this.galleryImages = arr.map(m => {return {
                    href: this.imgWpx(m.path, 900),
                    type: m.type.toLowerCase() + '/' + m.path.split('.').pop()
                }})
                this.galleryIndex = 0
            }
        }
    }
</script>

<style scoped>
.cell-due-amt{
    font-weight: 600;
    /*font-size: 15px;*/
}
.os-table:hover{
    cursor: pointer;
}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.c-name {
    display: inline-block;
    vertical-align: middle;
    width: 140px;
    max-width: 140px;
}
.f-12{
    font-size: 12px;
}
</style>
